import api from './api';

const handleError = (error, context = 'KOT error') => {
  console.error(`❌ ${context}:`, error.response?.data || error.message || error);
  throw error;
};

export const fetchKots = async (range = 'upcoming') => {
  try {
    const res = await api.get('/kots', { params: { range } });
    return res.data;
  } catch (error) {
    handleError(error, 'Failed to fetch KOTs');
  }
};

export const updateKotStatus = async (id, statusOrPayload) => {
  try {
    const payload = typeof statusOrPayload === 'string' ? { status: statusOrPayload } : (statusOrPayload || {});
    const res = await api.patch(`/kots/${id}/status`, payload);
    return res.data;
  } catch (error) {
    handleError(error, 'Failed to update KOT status');
  }
};

const openBlob = (blob, downloadName = '') => {
  const url = URL.createObjectURL(blob);
  if (downloadName) {
    const link = document.createElement('a');
    link.href = url;
    link.download = downloadName;
    document.body.appendChild(link);
    link.click();
    link.remove();
  } else {
    window.open(url, '_blank', 'noopener,noreferrer');
  }
  window.setTimeout(() => URL.revokeObjectURL(url), 60000);
};

export const viewKot = async (id) => {
  try {
    const res = await api.get(`/kots/${id}/preview`, { responseType: 'blob' });
    openBlob(res.data);
  } catch (error) {
    handleError(error, 'Failed to open KOT');
  }
};

export const downloadKotPdf = async (id) => {
  try {
    const res = await api.get(`/kots/${id}/pdf`, { responseType: 'blob' });
    openBlob(res.data, `KOT-${id}.pdf`);
  } catch (error) {
    handleError(error, 'Failed to download KOT');
  }
};
